import { datadogLogs } from '@datadog/browser-logs';
import { ImpButton } from '@imprint-payments/imprint-ui';
import { useEffect } from 'react';

import { EVENT } from '../../analytics/analyticsConsts';
import { useImpState } from '../../app/hooks';
import { HeaderHandler } from '../../components/HeaderHandler/HeaderHandler';
import Modal from '../../components/modal/Modal';
import {
  emitSDKEvent,
  emitSDKResult,
  isSDK,
  SDK_EVENTS,
  useSDKContext,
} from '../../utils/sdk';

export default function AsyncApplicationTimeout() {
  const { language, merchantData } = useImpState();
  const { result } = useSDKContext();

  useEffect(() => {
    datadogLogs.logger.info(EVENT.APPLICATION_TIMEOUT_PAGE_VIEWED);
  }, []);

  const handleBackToPartner = () => {
    emitSDKResult({
      result,
    });
    emitSDKEvent({
      event: SDK_EVENTS.CLOSED,
    });
  };

  const renderBackToPartnerButton = () => {
    return (
      <ImpButton
        variant="primary"
        buttonStyle="branded"
        onClick={handleBackToPartner}
      >
        {language.backTo + merchantData.rewardDetails.merchantName}
      </ImpButton>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100dvh',
      }}
    >
      <HeaderHandler />
      <Modal
        header={language.afterOtpAppStatusAsyncApplicationCreditHeader}
        body1={language.afterOtpAppStatusAsyncApplicationCreditBody}
        includeSupportEmail
        pillBtn1
      />
      {isSDK() && renderBackToPartnerButton()}
    </div>
  );
}
